import { render, staticRenderFns } from "./UpcomingActivitiesPage.vue?vue&type=template&id=d3d2c8f6&scoped=true"
import script from "./UpcomingActivitiesPage.vue?vue&type=script&lang=js"
export * from "./UpcomingActivitiesPage.vue?vue&type=script&lang=js"
import style0 from "./UpcomingActivitiesPage.vue?vue&type=style&index=0&id=d3d2c8f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d2c8f6",
  null
  
)

export default component.exports